





















































































import Vue from 'vue';
import Component from 'vue-class-component';
import ApplicationInfo from '@/store/models/ApplicationInfo';

@Component({
	components: {},
})
export default class DashboardHome extends Vue {
	private isLoading: boolean = false;
	private resumeApplicationNumber: string = '';

	public get applications(): ApplicationInfo[] { return this.$store.getters['DashboardModule/applications'] }

	public mounted(): void {
		this.getApplications();

		this.$store.commit('InterviewModule/updateApplicationNumber', null);
		this.$store.commit('InterviewModule/updateFormData', null);
		this.$store.commit('InterviewModule/updateFormErrorMap', {});
		this.$store.commit('InterviewModule/updateFilingType', null);
		this.$store.commit('InterviewModule/updatePageName', null);
		this.$store.commit('InterviewModule/updateResumeSectionName', null);
	}

	public async getApplications() {
		this.isLoading = true;
		await this.$store.dispatch('DashboardModule/getApplications');
		this.isLoading = false;
	}
}
